export interface Watchlist {
  id: string;
  name: string;
  isDefault: boolean;
  bondCount: number;
  createdAt: string;
}

/**
 * Prefix stamped on the client-only placeholder id that the store inserts while
 * a create is pending (see `buildOptimisticWatchlist`). The server never issues
 * an id with this prefix, so it is a reliable marker for "not yet persisted".
 */
export const OPTIMISTIC_WATCHLIST_ID_PREFIX = "optimistic-";

/** True for a temporary watchlist that only exists locally until the create resolves. */
export function isOptimisticWatchlistId(id: string): boolean {
  return id.startsWith(OPTIMISTIC_WATCHLIST_ID_PREFIX);
}
